import { type ReactElement } from 'react'
import { OptimisticPermissionButton } from 'app/components'
import { Stack, Group, Text } from '@mantine/core'
import { Size } from '@front/model'
import { type TeamNodeContentProps } from './types'

export const PermissionNode = ({ team }: TeamNodeContentProps): ReactElement => {
  return (
    <Stack>
      <Text className='text-center'>{team.name}</Text>
      <Group gap={Size.space.lg} justify='center' onClick={(e) => e.stopPropagation()}>
        <OptimisticPermissionButton
          buttonProps={{ buttonType: 'icon-rounded' }}
          entityId={team.teamId}
          drawerTitle={
            <>
              Permissions for all users in{' '}
              <Text inherit span c='brand'>
                {team.name}
              </Text>
            </>
          }
        />
      </Group>
    </Stack>
  )
}
